module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-12-6194ccb10293a9fa9ac3aea5afb40304.svg";